export default __webpack_public_path__ + "static/media/office-building.f4d7b419.svg";